<template>
    <div class="w-100 temp mr-1 position-relative d-flex flex-column"
         style="border-top: 0.125rem solid rgba(1, 153, 209, .5)">
        <div class="header-cover">
            <dv-scroll-board :config="emptyHeadConfig"/>
        </div>
        <dv-scroll-board v-if="notFinishCount>0" ref="deadListScroll" :config="deadListConfig"
                         :class="`h-${14*notFinishCount}`"/>
        <dv-scroll-board v-if="finishCount>0" ref="deadFinishListScroll" :config="deadFinishListConfig"
                         :class="`h-${14*finishCount}`"/>
        <div v-if="totalCount===0"
             class="position-absolute text-white d-flex align-content-center w-100 h-100 top">
            <div class="m-auto">
                <h1>无故障</h1>
            </div>
        </div>

    </div>
</template>

<script>
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";

const PAGE_SIZE = 6;
export default {
    name: "DiviceDeadList",
    data() {
        return {
            emptyHeadConfig: {
                header: ['设备编码', '设备名称', '报警文本', '开始时间', '结束时间', '持续时间/h', '当前状态'],
                data: [],
                headerBGC: '#131b4b',
                headerHeight: _pxGenerator(0.4),
            },
            fresh: null,
            notFinishCount: 0,
            totalCount: 0
        }
    },
    computed: {
        finishCount() {
            if (this.notFinishCount < PAGE_SIZE) {
                let temp = PAGE_SIZE - this.notFinishCount;
                if (temp > this.totalCount) {
                    temp = this.totalCount;
                }
                return temp;
            } else {
                return 0;
            }
        },
        deadListConfig() {
            return {
                header: this.emptyHeadConfig.header,
                headerHeight: 0,
                data: [],
                index: false,
                align: ['center'],
                rowNum: this.notFinishCount,
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)',
                hoverPause: false
            };
        },
        deadFinishListConfig() {
            return {
                header: this.emptyHeadConfig.header,
                headerHeight: 0,
                data: [],
                index: false,
                align: ['center'],
                rowNum: this.finishCount,
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)',
                hoverPause: false
            };
        },
    },
    mounted() {
        this.getDeadList();
        this.fresh = setInterval(() => {
            this.getDeadList()
        }, 60000);
    },
    beforeDestroy() {
        clearInterval(this.fresh);
    },
    methods: {
        getDeadList() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_ANDON_URL + "/sithMesAndonTask/machineDeadRecords",
                commonErrorHandle: false
            }).then(response => {
                if (response) {
                    this.handleRows(response);
                }
            })
        },
        handleRows(rows) {
            this.totalCount = rows.length;
            let tempList = [];
            let tempSpecialList = [];
            for (let row of rows) {
                let notFinish = row.statusName !== '已完成';
                let temp = [];
                temp.push(this.getText(row.machineCode, notFinish));
                temp.push(this.getText(row.machineName, notFinish));
                temp.push(this.getText(row.deadDescription, notFinish));
                temp.push(this.getText(row.startTime, notFinish));
                temp.push(this.getText(row.finishTime, notFinish));
                temp.push(this.getText(row.duration, notFinish));
                temp.push(this.getText(row.statusName, notFinish));
                if (notFinish) {
                    tempSpecialList.push(temp);
                } else {
                    tempList.push(temp);
                }
            }
            this.notFinishCount = tempSpecialList.length;
            if (this.notFinishCount > PAGE_SIZE) {
                this.notFinishCount = PAGE_SIZE;
            }

            this.deadListConfig.data = tempSpecialList;
            this.$refs.deadListScroll && this.$refs.deadListScroll.updateRows(tempSpecialList);
            this.deadFinishListConfig.data = tempList;
            this.$refs.deadFinishListScroll && this.$refs.deadFinishListScroll.updateRows(tempList);
        },
        getText(text, setColor) {
            return setColor ? this.setColor(text) : text;
        },
        setColor(text) {
            return `<span style="color: #f74d63;">${text}</span>`
        },
    },
}
</script>

<style scoped>
.temp {
}

.temp >>> .header {
    font-size: 1rem;
}

.header-cover >>> .rows {
    height: min-content !important;
}

.temp >>> .rows .row-item {
    font-size: 1rem;
    /*height: max-content !important;*/
    line-height: unset !important;
}

.temp >>> .rows .row-item .ceil {
    white-space: unset;
    text-overflow: unset;
    word-break: break-word;
}
</style>